
const MANAGEMENT_ROLES = ["ORGANISER", "ADMIN"];

export const hasManagementRole = (roles) => {
    if (roles == null) {
        return false;
    }
    return roles.filter(r => MANAGEMENT_ROLES.includes(r)).length > 0
}
